import React from "react";

/** Persistent warning shown on every page while the app points at a non-production environment. */
const TestEnvironmentBanner = () => {
  return (
    <div
      className="text-center text-white"
      style={{
        backgroundColor: "#d9534f",
        padding: "0.5rem 1rem",
        fontWeight: 600,
        fontSize: "0.9rem",
      }}
    >
      ⚠ This is a test environment. Data here is not real and may be reset at any time.
    </div>
  );
};

export default TestEnvironmentBanner;
